import { Log } from '@devanjs/log';
import type { WatchSource } from 'vue';
import type { MenuItem } from '../../menu';
import { services } from '../services';
import type { IntegrationInstallation } from '../types/integrationInstallation';

export const installMenu = (
  installations: IntegrationInstallation<any>[],
  item: MenuItem,
  condition?: WatchSource<boolean>,
) => {
  Log.tag('integrations')
    .space()
    .green(installations.map((i) => i.integration.code).join(', '))
    .lightGreen('Menu')
    .info(item.title);

  if (item.name === undefined) {
    item.name = item.title.toLowerCase();
  }

  installations.forEach((installation) => installation.menu.push(item));

  if (services.menu !== undefined) {
    if (condition !== undefined) {
      services.menu.addWhen(condition, item);
    } else {
      services.menu.add(item);
    }
  } else {
    Log.red('Integrations').info('Menu not found');
  }
};
